import { useAuth0 } from "@auth0/auth0-react";
import React from "react";
import { RiLogoutCircleFill } from "react-icons/ri";

const LogoutButton = () => {
  const { logout } = useAuth0();

  return (
    <button
      className="logout-btn"
      onClick={() => {
        localStorage.setItem("isLoggedIn", JSON.parse(false));
        logout({ returnTo: "https://cedrickmonesit.github.io/kixs-client/" });
      }}
    >
      <RiLogoutCircleFill className="icon" />
    </button>
  );
};

export default LogoutButton;
